import { registerLocale, setDefaultLocale } from 'react-datepicker'
import enUS from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import { DEFAULT_LANGUAGE, LANG_EN, LANG_ES } from './LanguageConfig'

const DATE_FORMAT_BY_LANG = {
    [LANG_EN]: 'dd/MM/yyyy',
    [LANG_ES]: 'dd/MM/yyyy',
}

let initialized = false

const initDatePickerLocale = () => {
    if (!initialized) {
        registerLocale(LANG_EN, enUS)
        registerLocale(LANG_ES, es)
        initialized = true
    }
}

const syncDatePickerLocale = (code) => {
    initDatePickerLocale()
    const locale = code === LANG_ES ? LANG_ES : LANG_EN
    setDefaultLocale(locale)
    return locale
}

const getDatePickerDateFormat = (code) => {
    return DATE_FORMAT_BY_LANG[code] || DATE_FORMAT_BY_LANG[DEFAULT_LANGUAGE]
}

export { initDatePickerLocale, syncDatePickerLocale, getDatePickerDateFormat }
